import React from 'react'

const MarketingSolution = () => {
  return (
    <div>
      Marketing Solutions
    </div>
  )
}

export default MarketingSolution
